'use client'

import { FC } from 'react'

import { ChevronPaginationIcon } from '@/components/icons'

import styles from './styles.module.css'
import { IPaginationProps } from './types'

const Pagination: FC<IPaginationProps> = ({
  totalPages,
  currentPage,
  onPageChange,
  className,
}) => {
  function handleClick(page: number) {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page)
    }
  }

  const renderPages = () => {
    const pages = [] as Array<JSX.Element>
    let startPage = Math.max(1, currentPage - 2)
    let endPage = Math.min(totalPages, currentPage + 2)

    if (currentPage <= 3) {
      startPage = 1
      endPage = Math.min(totalPages, 5)
    }

    if (currentPage >= totalPages - 2) {
      startPage = Math.max(1, totalPages - 4)
      endPage = totalPages
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <span
          key={i}
          className={`prose-label text-primary active:scale-95 hover:bg-primary-100 hover:text-white rounded-md
            ${styles['page-number']}
            ${currentPage === i ? 'bg-primary text-white hover:bg-primary' : ''}
          `}
          onClick={() => handleClick(i)}
        >
          {i}
        </span>,
      )
    }

    return pages
  }

  return (
    <div className={`${styles.pagination} ${className}`}>
      <ChevronPaginationIcon
        className="fill-primary cursor-pointer rotate-180 active:scale-90 rounded-md hover:bg-primary-100 hover:fill-white"
        onClick={() => handleClick(currentPage - 1)}
      />
      {renderPages()}
      <ChevronPaginationIcon
        className="fill-primary cursor-pointer active:scale-90 rounded-md hover:bg-primary-100 hover:fill-white"
        onClick={() => handleClick(currentPage + 1)}
      />
    </div>
  )
}

export default Pagination
